// client/src/hooks/useRewardPopup.js
// Custom hook for managing reward popups

import { useState, useCallback } from 'react';

const useRewardPopup = () => {
  const [popupState, setPopupState] = useState({
    isVisible: false,
    levelNumber: null,
    rewardType: 'level_complete',
    customMessage: null,
    videoSrc: null,
    gifSrc: null,
    audioSrc: null,
    duration: 10000
  });

  const showReward = useCallback((options = {}) => {
    setPopupState({
      isVisible: true,
      levelNumber: options.levelNumber || null,
      rewardType: options.rewardType || 'level_complete',
      customMessage: options.customMessage || null,
      videoSrc: options.videoSrc || null,
      gifSrc: options.gifSrc || null,
      audioSrc: options.audioSrc || null,
      duration: options.duration || 10000
    });
  }, []);

  const hideReward = useCallback(() => {
    setPopupState(prev => ({
      ...prev,
      isVisible: false
    }));
  }, []);

  const showLevelComplete = useCallback((levelNumber, options = {}) => {
    showReward({
      levelNumber,
      rewardType: 'level_complete',
      ...options
    });
  }, [showReward]);

  const showCourseComplete = useCallback((options = {}) => {
    showReward({
      rewardType: 'course_complete',
      ...options
    });
  }, [showReward]);

  const showAchievement = useCallback((achievementName, options = {}) => {
    showReward({
      rewardType: 'achievement',
      customMessage: `You've unlocked the "${achievementName}" achievement!`,
      ...options
    });
  }, [showReward]);

  return {
    popupState,
    showReward,
    hideReward,
    showLevelComplete,
    showCourseComplete,
    showAchievement
  };
};

export default useRewardPopup;
